import { render, staticRenderFns } from "./joinUnion.vue?vue&type=template&id=254ed7fe&scoped=true&"
import script from "./joinUnion.vue?vue&type=script&lang=js&"
export * from "./joinUnion.vue?vue&type=script&lang=js&"
import style0 from "./joinUnion.vue?vue&type=style&index=0&id=254ed7fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254ed7fe",
  null
  
)

component.options.__file = "joinUnion.vue"
export default component.exports